

export const DEFAULT_PAGE_SIZE = 50 ;
export const ALLOW_CUSTOM_DATE = true ;